export default __webpack_public_path__ + "static/media/pictogramBeaconUpload40.2c03f737.svg";